import React, { useState, useEffect, useRef, useCallback } from "react"
import Ward1Modal from './Ward1Modal';
import Ward2Modal from './Ward2Modal';
import ReceptionModal from './ReceptionModal';
import DoctorModal from './DoctorModal';

const HospitalMap = (props) => {
  const [ show, setShow ] = useState(false);
  const [ modalName, setModalName ] = useState();
  let modalRef = useRef(modalName);

  // useCallback hook is the answer!!
  const handleClick = useCallback((props) => { 
    console.log(props);
      setModalName(props.name);
      modalRef.current = props.name;
      setShow(true);
  }, [modalName])

 
  return (
    <React.Fragment>
      { modalRef.current === 'ward1' && <Ward1Modal open={show} onClose={() => setShow(false)} /> }
      { modalRef.current === 'ward2' && <Ward2Modal open={show} onClose={() => setShow(false)} /> }
      { modalRef.current === 'reception' && <ReceptionModal open={show} onClose={() => setShow(false)} />}
      { modalRef.current === 'doctors' && <DoctorModal open={show} onClose={() => setShow(false)} />}

      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className="hospitalMap"
        viewBox="-0.5 -0.5 761 692"
        {...props}
      >
     
        <path
          fill="#dae8fc"
          stroke="#6c8ebf"
          d="M390 80h80v5h-80z"
          pointerEvents="all"

        />
        <path
          fill="#dae8fc"
          stroke="#6c8ebf"
          d="M427.5 42.5h5v80h-5z"
          pointerEvents="all"
    
        />
        <circle
          cx={430}
          cy={82.5}
          r={40}
          fill="none"
          stroke="#6c8ebf"
          pointerEvents="all"
         
        />
    
  
        
        <path fill="none" d="M350 0h140v40H350z" pointerEvents="all" />
        <switch transform="translate(-.5 -.5)">
          <foreignObject
            width="100%"
            height="100%"
            pointerEvents="none"
            requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
            style={{
              overflow: "visible",
              textAlign: "left",
            }}
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                display: "flex",
                alignItems: "unsafe center",
                justifyContent: "unsafe center",
                width: 1,
                height: 1,
                paddingTop: 20,
                marginLeft: 420,
              }}
            >
              <div
                data-drawio-colors="color: rgb(0, 0, 0);"
                style={{
                  boxSizing: "border-box",
                  fontSize: 0,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    fontSize: 12,
                    fontFamily: "Helvetica",
                    color: "#000",
                    lineHeight: 1.2,
                    pointerEvents: "all",
                    whiteSpace: "nowrap",
                  }}
                >
                  <font
                    style={{
                      fontSize: 18,
                    }}
                  >
                    {"Main Entrance"}
                  </font>
                </div>
              </div>
            </div>
          </foreignObject>
          <text
            x={420}
            y={24}
            fontFamily="Helvetica"
            fontSize={12}
            textAnchor="middle"
            className="entranceText"
          >
            {"Main Entrance"}
          </text>
        </switch>
        <path
          fill="#fad9d5"
          stroke="#ae4132"
          d="M0 67.5h320V360H0z"
          pointerEvents="all"
          className="ward1"
        />
        <path stroke="#000" d="M0 66.9h320v10H0z" pointerEvents="all" />
        <path
          stroke="#000"
          d="M10 76.3v266.11H0V76.3zM10 337.63h310v10H10zM320 76.3v87.97h-10V76.3z"
          pointerEvents="all"
        />
        <path stroke="#000" d="M320 254.44v87.97h-10v-87.97z" pointerEvents="all" />
        <path
          fill="#FFF"
          stroke="#000"
          d="M40 80.7h60v83.57H40z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={18.57}
          x={46}
          y={83.02}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.32}
          ry={2.32}
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M40 94.62h60v11.61H40zM130 80.7h60v83.57h-60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={18.57}
          x={136}
          y={83.02}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.32}
          ry={2.32}
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M130 94.62h60v11.61h-60zM220 80.7h60v83.57h-60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={18.57}
          x={226}
          y={83.02}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.32}
          ry={2.32}
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M220 94.62h60v11.61h-60zM280 331.4h-60v-83.57h60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={18.57}
          x={226}
          y={250.16}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.32}
          ry={2.32}
          transform="rotate(180 250 289.62)"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M280 317.47h-60v-11.61h60zM186 330.52h-60v-82.69h60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={18.38}
          x={132}
          y={250.14}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.3}
          ry={2.3}
          transform="rotate(180 156 289.18)"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M186 316.74h-60v-11.48h60zM96 330.52H36v-82.69h60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={18.38}
          x={42}
          y={250.14}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.3}
          ry={2.3}
          transform="rotate(180 66 289.18)"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M96 316.74H36v-11.48h60z"
          pointerEvents="all"
        />

        <path fill="none" d="M80 191.76h170v40H80z" pointerEvents="all" />
        <switch transform="translate(-.5 -.5)">
          <foreignObject
            width="100%"
            height="100%"
            pointerEvents="none"
            requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
            style={{
              overflow: "visible",
              textAlign: "left",
            }}
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                display: "flex",
                alignItems: "unsafe center",
                justifyContent: "unsafe center",
                width: 1,
                height: 1,
                paddingTop: 212,
                marginLeft: 165,
              }}
            >
              <div
                data-drawio-colors="color: rgb(0, 0, 0);"
                style={{
                  boxSizing: "border-box",
                  fontSize: 0,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "block",
                    fontSize: 18,
                    fontFamily: "Helvetica",
                    color: "#000",
                    lineHeight: 1.2,
                    pointerEvents: "all",
                    whiteSpace: "nowrap",
                  }}
                >
                  <a href="#ward1" onClick={() => handleClick({ name: 'ward1', show: true })}>Children's Ward 1</a>
                </div>
              </div>
            </div>
          </foreignObject>
          <text
            x={165}
            y={217}
            fontFamily="Helvetica"
            fontSize={18}
            textAnchor="middle"
            className="ward1Text"
          >
            Children's Ward 1
          </text>
        </switch>

        <path
          fill="#d5e8d4"
          stroke="#82b366"
          d="M520 67.5h230V400H520z"
          pointerEvents="all"
          className="receptionArea"
        />
        <path stroke="#000" d="M520 67.5h230v10H520z" pointerEvents="all" />
        <path
          fill="#FFF"
          stroke="#000"
          strokeMiterlimit={10}
          d="m651.07 158.71 14.59-19.29a9 9 0 0 1 9.14-3.66 99.958 99.958 0 0 1 22.22 21.62c.8 3.48-.54 7.11-3.41 9.24l-18.89 15.1c-2.26 1.5-5.74.97-8.5-1.3l-13.62-13.25c-2.34-2.7-2.97-6.16-1.53-8.46Z"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeMiterlimit={10}
          d="M647.8 163.19c-.38-.8-.01-1.83.83-2.3.84-.47 1.84-.21 2.22.59a62.861 62.861 0 0 0 21.5 20.93c.32.56.31 1.28-.02 1.9-.32.62-.93 1.07-1.6 1.19-9.46-5.36-17.31-13-22.93-22.31"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeMiterlimit={10}
          d="M730 100v150h-40v-60l-50-50h-60v-40Z"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M720 342.5H590v-10h130z"
          pointerEvents="all"
        />
        <rect
          width={15}
          height={80}
          x={580}
          y={272.5}
          fill="#FFF"
          stroke="#000"
          pointerEvents="all"
          rx={3}
          ry={3}
          transform="rotate(180 655 312.5)"
        />
        <rect
          width={120}
          height={15}
          x={595}
          y={272.5}
          fill="#FFF"
          stroke="#000"
          pointerEvents="all"
          rx={3}
          ry={3}
          transform="rotate(180 655 312.5)"
        />
        <rect
          width={60}
          height={65}
          x={595}
          y={287.5}
          fill="#FFF"
          stroke="#000"
          pointerEvents="all"
          rx={3}
          ry={3}
          transform="rotate(180 655 312.5)"
        />
        <rect
          width={60}
          height={65}
          x={655}
          y={287.5}
          fill="#FFF"
          stroke="#000"
          pointerEvents="all"
          rx={3}
          ry={3}
          transform="rotate(180 655 312.5)"
        />
        <rect
          width={15}
          height={80}
          x={715}
          y={272.5}
          fill="#FFF"
          stroke="#000"
          pointerEvents="all"
          rx={3}
          ry={3}
          transform="rotate(180 655 312.5)"
        />
        <path stroke="#000" d="M520 375.25h230v10H520z" pointerEvents="all" />
        <path fill="none" d="M520 190h150v40H520z" pointerEvents="all" />
        <switch transform="translate(-.5 -.5)">
          <foreignObject
            width="100%"
            height="100%"
            pointerEvents="none"
            requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
            style={{
              overflow: "visible",
              textAlign: "left",
            }}
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                display: "flex",
                alignItems: "unsafe center",
                justifyContent: "unsafe center",
                width: 1,
                height: 1,
                paddingTop: 210,
                marginLeft: 595,
              }}
            >
              <div
                data-drawio-colors="color: rgb(0, 0, 0);"
                style={{
                  boxSizing: "border-box",
                  fontSize: 0,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    fontSize: 18,
                    fontFamily: "Helvetica",
                    color: "#000",
                    lineHeight: 1.2,
                    pointerEvents: "all",
                    whiteSpace: "nowrap",
                  }}
                >
                  <a href="#reception" onClick={() => handleClick({ name: 'reception', show: true })}>Reception Area</a>
                </div>
              </div>
            </div>
          </foreignObject>
          <text
            x={595}
            y={215}
            fontFamily="Helvetica"
            fontSize={18}
            textAnchor="middle"

          >
            {"Reception Area"}
          </text>
        </switch>
        <path
          fill="#e3c800"
          stroke="#b09500"
          d="M0 350h320v340.5H0z"
          pointerEvents="all"
          className="ward2"
        />
        <path
          stroke="#000"
          d="M10 330v359.98H0V330zM10 680.33h310v10H10zM320 350v112.29h-10V350z"
          pointerEvents="all"
        />
        <path stroke="#000" d="M320 577.69v103.5h-10v-103.5z" pointerEvents="all" />
        <path
          fill="#FFF"
          stroke="#000"
          d="M40 382.08h60v98.32H40z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={21.85}
          x={46}
          y={384.81}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.73}
          ry={2.73}
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M40 398.47h60v13.66H40zM130 382.08h60v98.32h-60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={21.85}
          x={136}
          y={384.81}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.73}
          ry={2.73}
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M130 398.47h60v13.66h-60zM220 382.08h60v98.32h-60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={21.85}
          x={226}
          y={384.81}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.73}
          ry={2.73}
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M220 398.47h60v13.66h-60zM280 677.06h-60v-98.32h60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={21.85}
          x={226}
          y={581.46}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.73}
          ry={2.73}
          transform="rotate(180 250 627.89)"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M280 660.67h-60v-13.66h60zM186 676.02h-60v-97.29h60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={21.62}
          x={132}
          y={581.43}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.7}
          ry={2.7}
          transform="rotate(180 156 627.37)"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M186 659.8h-60v-13.51h60zM96 676.02H36v-97.29h60z"
          pointerEvents="all"
        />
        <rect
          width={48}
          height={21.62}
          x={42}
          y={581.43}
          fill="none"
          stroke="#000"
          pointerEvents="all"
          rx={2.7}
          ry={2.7}
          transform="rotate(180 66 627.37)"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M96 659.8H36v-13.51h60z"
          pointerEvents="all"
        />

        <path fill="none" d="M80 521.03h170v40H80z" pointerEvents="all" />
        <switch transform="translate(-.5 -.5)">
          <foreignObject
            width="100%"
            height="100%"
            pointerEvents="none"
            requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
            style={{
              overflow: "visible",
              textAlign: "left",
            }}
            className="ward2Text"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                display: "flex",
                alignItems: "unsafe center",
                justifyContent: "unsafe center",
                width: 1,
                height: 1,
                paddingTop: 541,
                marginLeft: 165,
              }}
            >
              <div
                data-drawio-colors="color: rgb(0, 0, 0);"
                style={{
                  boxSizing: "border-box",
                  fontSize: 0,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    fontSize: 18,
                    fontFamily: "Helvetica",
                    color: "#000",
                    lineHeight: 1.2,
                    pointerEvents: "all",
                    whiteSpace: "nowrap",
                  }}
                >
                  <a href="#ward2" onClick={() => handleClick({ name: 'ward2', show: true })}>Children's Ward 2</a>
                </div>
              </div>
            </div>
          </foreignObject>
          <text
            x={165}
            y={546}
            fontFamily="Helvetica"
            fontSize={18}
            textAnchor="middle"
          >
            {"Children's Ward 2"}
          </text>
        </switch>
        <path stroke="#000" d="M760 67.5V680h-10V67.5z" pointerEvents="all" />
        <path
          fill="#e1d5e7"
          stroke="#9673a6"
          d="M520 381.5h230v299H520z"
          pointerEvents="all"
          className="doctorsOffice"
        />
        <path stroke="#000" d="M520 670.5h230v10H520z" pointerEvents="all" />
        <a xlinkHref="/Map#doctors" onClick={() => handleClick({ name: 'doctors', show: true })}>
          <path stroke="#000" d="M530 581.5V670h-10v-88.5z" pointerEvents="all" />
        </a>
        <path
          fill="#FFF"
          stroke="#000"
          strokeMiterlimit={10}
          d="m668.93 491.29-14.59 19.29a9 9 0 0 1-9.14 3.66 99.958 99.958 0 0 1-22.22-21.62c-.8-3.48.54-7.11 3.41-9.24l18.89-15.1c2.26-1.5 5.74-.97 8.5 1.3l13.62 13.25c2.34 2.7 2.97 6.16 1.53 8.46Z"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeMiterlimit={10}
          d="M672.2 486.81c.38.8.01 1.83-.83 2.3-.84.47-1.84.21-2.22-.59a62.861 62.861 0 0 0-21.5-20.93c-.32-.56-.31-1.28.02-1.9.32-.62.93-1.07 1.6-1.19 9.46 5.36 17.31 13 22.93 22.31"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeMiterlimit={10}
          d="M590 550V400h40v60l50 50h60v40ZM730 652.51v1.99c0 1.06-.42 2.08-1.17 2.83s-1.77 1.17-2.83 1.17h-52c-1.06 0-2.08-.42-2.83-1.17a4.004 4.004 0 0 1-1.17-2.83v-1.99Z"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M670 603.54h60v46.97h-60z"
          pointerEvents="all"
        />
        <path
          fill="none"
          stroke="#000"
          strokeMiterlimit={10}
          d="M676 603.54c-.32-1.22-.04-2.52.75-3.5.79-.99 1.99-1.54 3.25-1.5h40c1.26-.04 2.46.51 3.25 1.5.79.98 1.07 2.28.75 3.5"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          d="M715 658.5h6v2h-6z"
          pointerEvents="all"
        />
        <path
          fill="#FFF"
          stroke="#000"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          d="m573.55 637.88-2.98-23.84c-.57-3.51.99-7.01 3.97-8.94 10.21-1.6 20.61-1.6 30.82 0a8.926 8.926 0 0 1 3.98 8.94l-2.98 23.84c-.57 2.64-3.42 4.67-6.96 4.97h-18.89c-3.54-.3-6.39-2.33-6.96-4.97Zm26.66 4.97 5.11 6.29m-10.78-6.29 1.7 7.19m-8.51-7.19-2.27 7.19m-3.41-7.19-5.68 6.29m-1.7-.33c10.51 1.63 21.27 1.63 31.79 0l4.54 3.97a103.744 103.744 0 0 1-40.87 0Z"
          pointerEvents="all"
        />

        <path fill="none" d="M565 560h160v40H565z" pointerEvents="all" />
        <switch transform="translate(-.5 -.5)">
          <foreignObject
            width="100%"
            height="100%"
            pointerEvents="none"
            requiredFeatures="http://www.w3.org/TR/SVG11/feature#Extensibility"
            style={{
              overflow: "visible",
              textAlign: "left",
            }}
            className="doctorsText"
          >
            <div
              xmlns="http://www.w3.org/1999/xhtml"
              style={{
                display: "flex",
                alignItems: "unsafe center",
                justifyContent: "unsafe center",
                width: 1,
                height: 1,
                paddingTop: 580,
                marginLeft: 645,
              }}
            >
              <div
                data-drawio-colors="color: rgb(0, 0, 0);"
                style={{
                  boxSizing: "border-box",
                  fontSize: 0,
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    fontSize: 18,
                    fontFamily: "Helvetica",
                    color: "#000",
                    lineHeight: 1.2,
                    pointerEvents: "all",
                    whiteSpace: "nowrap",
                  }}
                >
                  <a href="#doctors" onClick={() => handleClick({ name: 'doctors', show: true })}>Doctor's Office</a>
                </div>
              </div>
            </div>
          </foreignObject>
          <text
            x={645}
            y={585}
            fontFamily="Helvetica"
            fontSize={18}
            textAnchor="middle"
          >
            {"Doctor's offfice 1"}
          </text>
        </switch>
        <path stroke="#000" d="M530 381.5V470h-10v-88.5z" pointerEvents="all" />

      </svg>
    </React.Fragment>
  )
}
export default HospitalMap;
